import { render, staticRenderFns } from "./MarketSection.vue?vue&type=template&id=6d196a0c&scoped=true"
import script from "./MarketSection.vue?vue&type=script&lang=js"
export * from "./MarketSection.vue?vue&type=script&lang=js"
import style0 from "./MarketSection.vue?vue&type=style&index=0&id=6d196a0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d196a0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d196a0c')) {
      api.createRecord('6d196a0c', component.options)
    } else {
      api.reload('6d196a0c', component.options)
    }
    module.hot.accept("./MarketSection.vue?vue&type=template&id=6d196a0c&scoped=true", function () {
      api.rerender('6d196a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/MarketSection.vue"
export default component.exports